module.exports = __webpack_public_path__ + "img/youtube.3b52394a.svg";